
export default class WebSocketService
{
    private static socket : WebSocket;
    public static listeners : Function[] = [] as Function[];

	public static openConnection()
	{
        if (!this.socket || this.socket.readyState != WebSocket.OPEN)
        {
            this.socket = new WebSocket(process.env.VUE_APP_WSS_PATH);
            this.socket.onopen = this.onOpen;
            this.socket.onclose = this.onClose;
            this.socket.onerror = this.onError;
            this.socket.onmessage = this.onMessage;

            this.listeners = [] as Function[];
        }
	}

    private static onOpen()
    {
        console.log("connection established");
    }

    private static onClose()
    {
        console.log("connection closed");
    }

    private static onError(event : Event)
    {
        console.log("error");
    }

    private static onMessage(event : Event)
    {
        /*
        let obj = {};
        obj.testid = 12;
        obj.name = "test";

        WebSocketService.sendMessage(JSON.stringify(obj));
        */
        if (WebSocketService.listeners)
        {
            for (let f : Function of WebSocketService.listeners)
            {
                f(event.data);
            }
        }
    }

    public static sendMessage(message : string)
    {
        if (this.socket && this.socket.readyState === WebSocket.OPEN)
        {
            this.socket.send(message);
        }
    }

    public static addListener(callback : Function)
    {
        this.listeners.push(callback);
    }

    public static removeListener(callback : Function)
    {
        for (let i : number = 0; i < this.listeners.length; i++)
        {
            if (this.listeners[i] === callback)
            {
                this.listeners.splice(i, 1);
                break;
            }
        }
    }
}
